module.exports = __webpack_public_path__ + "img/P29-en.1ae04ae0.png";